import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = state => {
  return {
    contractEthereumBalance: state.account.contractEthereumBalance
  };
};

const connectedContractEthereumBalance = ({contractEthereumBalance}) => (
  <h4>Balance: {contractEthereumBalance} ETH</h4>
);

const ContractEthereumBalance = connect(mapStateToProps)(connectedContractEthereumBalance);

export default ContractEthereumBalance;


// WEBPACK FOOTER //
// ./src/components/EtherPage/ContractEthereumBalance.js